'use strict';

var React = require('react');
var index = require('./index-fccd5f88.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css = "@-webkit-keyframes Loader_module_spin__a6cfff64 {\n  0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n  }\n  100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n  }\n}\n@-moz-keyframes Loader_module_spin__a6cfff64 {\n  0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n  }\n  100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n  }\n}\n@-ms-keyframes Loader_module_spin__a6cfff64 {\n  0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n  }\n  100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n  }\n}\n@keyframes Loader_module_spin__a6cfff64 {\n  0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n  }\n  100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n  }\n}\n\n.Loader_module_visuallyHidden__a6cfff64 {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.Loader_module_youtubeVideo__a6cfff64 {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.Loader_module_Loading__a6cfff64 {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n}\n.Loader_module_Loading__a6cfff64.Loader_module_DarkMode__a6cfff64 .Loader_module_Content__a6cfff64 svg {\n  stroke: #fff;\n}\n.Loader_module_Loading__a6cfff64 .Loader_module_Content__a6cfff64 {\n  width: 30px;\n  height: 30px;\n  animation: Loader_module_spin__a6cfff64 1s infinite;\n}\n.Loader_module_Loading__a6cfff64 .Loader_module_Content__a6cfff64 svg {\n  stroke: #444f6b;\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/Atoms/Loader/Loader.module.scss");
var modules_b825b997 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"Loader_module_visuallyHidden__a6cfff64","youtubeVideo":"Loader_module_youtubeVideo__a6cfff64","Loading":"Loader_module_Loading__a6cfff64","DarkMode":"Loader_module_DarkMode__a6cfff64","Content":"Loader_module_Content__a6cfff64","spin":"Loader_module_spin__a6cfff64"};

var Loader = function Loader(_ref) {
  var extraClass = _ref.extraClass,
    darkMode = _ref.darkMode,
    loaderHeight = _ref.loaderHeight,
    loaderWidth = _ref.loaderWidth;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_b825b997.Loading, darkMode ? modules_b825b997.DarkMode : "", extraClass || ""].join(" ")
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_b825b997.Content,
    style: {
      height: loaderHeight,
      width: loaderWidth
    }
  }, /*#__PURE__*/React__default["default"].createElement(Circle, null)));
};
var Circle = function Circle() {
  return /*#__PURE__*/React__default["default"].createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "15 0 10 40"
  }, /*#__PURE__*/React__default["default"].createElement("circle", {
    strokeDasharray: "80, 20",
    cx: "20",
    cy: "20",
    r: "15.91549430918954",
    fill: "transparent",
    strokeWidth: "6",
    strokeDashoffset: "25"
  }));
};
Loader.propTypes = {
  extraClass: index.propTypes.exports.string,
  darkMode: index.propTypes.exports.bool,
  loaderHeight: index.propTypes.exports.string,
  loaderWidth: index.propTypes.exports.string
};

exports.Loader = Loader;
